/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFrozenAuthorizedSigner_Query = { readonly __typename: 'Query', readonly frozenAuthorizedSigner: boolean | null };


export type GetFrozenAuthorizedSignerVariables = _Types.Exact<{
  companyId: _Types.Scalars['String']['input'];
}>;


export type GetFrozenAuthorizedSigner = GetFrozenAuthorizedSigner_Query;


export const GetFrozenAuthorizedSignerDocument = gql`
    query GetFrozenAuthorizedSigner($companyId: String!) {
  frozenAuthorizedSigner(companyId: $companyId)
}
    `;

/**
 * __useGetFrozenAuthorizedSigner__
 *
 * To run a query within a React component, call `useGetFrozenAuthorizedSigner` and pass it any options that fit your needs.
 * When your component renders, `useGetFrozenAuthorizedSigner` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFrozenAuthorizedSigner({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetFrozenAuthorizedSigner(baseOptions: Apollo.QueryHookOptions<GetFrozenAuthorizedSigner, GetFrozenAuthorizedSignerVariables> & ({ variables: GetFrozenAuthorizedSignerVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFrozenAuthorizedSigner, GetFrozenAuthorizedSignerVariables>(GetFrozenAuthorizedSignerDocument, options);
      }
export function useGetFrozenAuthorizedSignerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFrozenAuthorizedSigner, GetFrozenAuthorizedSignerVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFrozenAuthorizedSigner, GetFrozenAuthorizedSignerVariables>(GetFrozenAuthorizedSignerDocument, options);
        }
export function useGetFrozenAuthorizedSignerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFrozenAuthorizedSigner, GetFrozenAuthorizedSignerVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFrozenAuthorizedSigner, GetFrozenAuthorizedSignerVariables>(GetFrozenAuthorizedSignerDocument, options);
        }
export type GetFrozenAuthorizedSignerHookResult = ReturnType<typeof useGetFrozenAuthorizedSigner>;
export type GetFrozenAuthorizedSignerLazyQueryHookResult = ReturnType<typeof useGetFrozenAuthorizedSignerLazyQuery>;
export type GetFrozenAuthorizedSignerSuspenseQueryHookResult = ReturnType<typeof useGetFrozenAuthorizedSignerSuspenseQuery>;
export type GetFrozenAuthorizedSignerQueryResult = Apollo.QueryResult<GetFrozenAuthorizedSigner, GetFrozenAuthorizedSignerVariables>;